import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    marginTop: '40px'
  },
  title: {
    color: theme.palette.black.dark,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '130%',
    marginBottom: '20px'
  },
  infosContainer: {
    borderRadius: '12px',
    border: '2px solid #FFF',
    background: 'linear-gradient(113deg, rgba(255, 255, 255, 0.66) 0%, rgba(255, 255, 255, 0.64) 110.84%)',
    padding: '27px 29px'
  },
  infosTitleContainer:{
    display: 'flex',
  },
  infosNameContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '12px'
  },
  modelName: {
    color: theme.palette.black.dark,
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '120%',
  },
  reference: {
    borderRadius: '16px',
    background: theme.palette.grey.grey100,
    padding: '4px 10px',
    color: theme.palette.grey.grey600,
    fontSize: '10px',
    fontWeight: 700,
    marginTop: '4px'
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
  },
  descriptionTitle: {
    fontWeight: 600,
    fontSize: '12px',
    color: theme.palette.grey.grey400,
    lineHeight: '130%',
    marginBottom: '13px'
  },
  descriptionText: {
    fontSize: '12px',
    color: theme.palette.grey.grey700
  },
  label: {
    fontSize:'12px',
    color: theme.palette.grey.grey400,
    fontWeight: 600,
    marginBottom: '13px'
  },
  expirationDate: {
    display: 'flex',
    alignItems:'center'
  },
  expirationDateText: {
    color: theme.palette.grey.grey700,
    fontSize: '14px',
    marginLeft: '8px',
    whiteSpace: 'nowrap',
  },
  expDateContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto'
  },
  data: {
    display: 'flex',
    margin: '20px 0px',
  },
  attributeContainer: {
    border: `1px solid ${theme.palette.grey.grey100}`,
    background: 'rgba(242, 243, 247, 0.20)',
    margin: '14px 26px',
    padding: '16px',
    maxHeight: '200px',
    overflow: 'auto',
  },
}));

export default useStyles;
